import { HBBTV_CONST } from '../constants/constants';

const initKeySet = (keyset) => {
    const node = document.getElementById(HBBTV_CONST.APP_MNGR_ID);
    if (node && node.getOwnerApplication) {
        const app = node.getOwnerApplication(document);
        const privateData = app.privateData;
        const myKeyset = privateData.keyset;
        if (myKeyset) {
            if (myKeyset.setValue) {
                if (!keyset || !Array.isArray(keyset) || keyset.length === 0)
                    myKeyset.setValue(myKeyset.RED | myKeyset.BLUE | myKeyset.GREEN | myKeyset.YELLOW | myKeyset.NAVIGATION);
                else {
                    let set = undefined;
                    keyset.forEach(key => {
                        if (set === undefined)
                            set = myKeyset[key];
                        else set = set | myKeyset[key];
                    });
                    myKeyset.setValue(set);
                }
            } else {
                console.log('setValue is not defined');
            }// NOOOOO, READONLY!!! else myKeyset.value = myKeyset.RED | myKeyset.BLUE | myKeyset.GREEN | myKeyset.YELLOW | myKeyset.NAVIGATION;
        }
    }
}

export { initKeySet };